import Vue from 'vue';
import OutOfServicePhone from '@/Classes/800/OutOfServicePhone';
export default {
  data() {
    return {
      ambulance107AllActive: [],
      ambulance107AllActiveAlarm: [],
    };
  },
  methods: {
    getListOfAllActive107Codes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllActiveOutOfServicePhones').then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          let temp = this.$store.state.outOfServicePhoneModule.allActiveOutOfServicePhones;
          for (let i = 0; i < this.ambulance107AllActive.length; i++) {
            clearInterval(this.ambulance107AllActive[i].durationInterval);
          }
          this.ambulance107AllActive = [];
          for (let i = 0; i < temp.length; i++) {
            let createUser = '';
            let time = '-';
            if (temp[i].creationUser) {
              let fName = temp[i].creationUser.firstName;
              let lName = temp[i].creationUser.lastName;
              createUser = fName + ' ' + lName;
            }
            if (temp[i].startDate) {
              time = Vue.moment(temp[i].startDate).format('HH:mm:ss jYYYY/jM/jD');
            }
            let totalDuration = temp[i].totalDuration;
            let duration = Number(temp[i].totalDuration) * 60;
            duration = duration * 1000;
            const date1 = new Date(temp[i].currentDate);
            let date2 = new Date(temp[i].startDate);
            const timeDifference = date1.getTime() - date2.getTime();
            this.ambulance107AllActive.push({
              id: temp[i].id,
              zone: temp[i].phone && temp[i].phone.zone ? temp[i].phone.zone : '-',
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              phoneNumber:
                temp[i].phone && temp[i].phone.phoneNumber ? temp[i].phone.phoneNumber : '-',
              note: temp[i].note ? temp[i].note : '-',
              user: createUser,
              time: time,
              duration: this.convertMinutesToTime(totalDuration),
              // temp[i].isConfirmed
              //   ? this.convertMinutesToTime(timeDifference / 60000)
              //   : this.convertMinutesToTime(totalDuration),
              durationInterval: null,
              isConfirmed: temp[i].isConfirmed,
              totalDuration,
            });
            if (temp[i].isConfirmed) {
              const index = this.ambulance107AllActive.length - 1;
              totalDuration = totalDuration * 60;
              this.ambulance107AllActive[index].durationInterval = setInterval(() => {
                totalDuration--;
                if (totalDuration > 0) {
                  const timeDiff = totalDuration * 1000 - timeDifference;
                  this.ambulance107AllActive[index].duration = this.convertMinutesToTime(
                    timeDiff / 60000,
                  );
                } else {
                  clearInterval(this.ambulance107AllActive[index].durationInterval);
                  this.ambulance107AllActive[index].duration = '00:00:00';
                }
              }, 1000);
            }
            // if (durationFlag) {
            //   const index = this.ambulance107AllActive.length - 1;
            //   this.ambulance107AllActive[index].durationInterval = setInterval(
            //     () => {
            //       duration = duration - 1000;
            //       if (duration > 0) {
            //         this.ambulance107AllActive[index].duration =
            //           this.msToTime(duration);
            //       } else {
            //         this.ambulance107AllActive[index].duration = "00:00";
            //         clearInterval(
            //           this.ambulance107AllActive[index].durationInterval
            //         );
            //       }
            //     },
            //     1000
            //   );
            // } else {
            //   const index = this.ambulance107AllActive.length - 1;
            //   this.ambulance107AllActive[index].duration = "00:00";
            // }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAllActive107Codes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAllActive107Codes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfAllActiveAlarm107Codes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllActiveAlarmOutOfServicePhones').then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          let temp = this.$store.state.outOfServicePhoneModule.allActiveAlarmOutOfServicePhones;
          for (let i = 0; i < this.ambulance107AllActiveAlarm.length; i++) {
            clearInterval(this.ambulance107AllActiveAlarm[i].durationInterval);
          }
          this.ambulance107AllActiveAlarm = [];
          for (let i = 0; i < temp.length; i++) {
            let time = '-';
            if (temp[i].startDate) {
              time = Vue.moment(temp[i].startDate).format('HH:mm:ss jYYYY/jM/jD');
            }
            let duration = Number(temp[i].totalDuration) * 60;
            duration = duration * 1000;
            let date1 = new Date(temp[i].currentDate);
            let date2 = new Date(temp[i].startDate);
            let tempDate = date2.getTime();
            let mainDate = Number(tempDate) + Number(duration);
            let dd = date1.getTime() - mainDate;
            duration = Number(dd);
            this.ambulance107AllActiveAlarm.push({
              id: temp[i].id,
              ambulanceCode: temp[i].phone && temp[i].phone.code ? temp[i].phone.code : '-',
              time: time,
              duration: duration,
              durationInterval: null,
              isConfirmed: temp[i].isConfirmed,
            });
            const index = this.ambulance107AllActiveAlarm.length - 1;
            duration = duration + 1000;
            this.ambulance107AllActiveAlarm[index].duration = this.msToTime(duration);
            // this.ambulance107AllActiveAlarm[index].durationInterval = setInterval(() => {
            // }, 1000);
          }
          //   this.ambulance107AllActiveAlarm =
          //     this.convertIntoTwoColumnGroupList();
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAllActiveAlarm107Codes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAllActiveAlarm107Codes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addOutOfServicePhoneFunction: function () {
      if (!this.outOfServicePhone.phoneId) {
        this.snackText = 'کد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.outOfServicePhone.note) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.outOfServicePhone.note.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let totalDuration = 0;
      let hour = Number(this.hour * 60);
      totalDuration = Number(hour) + Number(this.minute);
      if (!totalDuration) {
        this.snackText = 'مدت زمان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.outOfServicePhone.totalDuration = Number(totalDuration);
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addOutOfServicePhone', this.outOfServicePhone).then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' کد با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.outOfServicePhone = new OutOfServicePhone.OutOfServicePhone('', null, null);
          this.minute = null;
          this.hour = null;
          this.getListOfAllActive107Codes();
          this.getListOfAllActiveAlarm107Codes();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    extendOutOfServicePhoneFunction: function () {
      let totalDuration = 0;
      let hour = Number(this.extendHour * 60);
      totalDuration = Number(hour) + Number(this.extendMinute);
      if (!totalDuration) {
        this.snackText = 'مدت زمان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let data = {
        id: Number(this.outOfServicePhoneId),
        duration: Number(totalDuration),
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('extendOutOfServicePhone', data).then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.extendTimeModal = false;
          this.disabelConfirm = false;
          this.snackText = ' زمان با موفقیت تمدید شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.extendMinute = null;
          this.extendHour = null;
          this.getListOfAllActive107Codes();
          this.getListOfAllActiveAlarm107Codes();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.disabelConfirm = false;
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.extendOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.extendOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    endOutOfServicePhoneFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('endOutOfServicePhone', this.outOfServicePhoneId).then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfAllActive107Codes();
          this.getListOfAllActiveAlarm107Codes();
          this.snackText = ' تغییر وضعیت با موفقیت انجام شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.endOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.endOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    confirmOutOfServicePhoneFunction: function () {
      let totalDuration = 0;
      let hour = Number(this.confirmHour * 60);
      totalDuration = Number(hour) + Number(this.confirmMinute);
      if (!totalDuration) {
        this.snackText = 'مدت زمان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let data = {
        id: this.outOfServicePhoneId,
        duration: totalDuration,
        note: this.confirmNote,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('confirmOutOfServicePhone', data).then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.confirmModal = false;
          this.confirmNote = '';
          this.confirmHour = null;
          this.confirmMinute = null;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfAllActive107Codes();
          this.getListOfAllActiveAlarm107Codes();
          this.snackText = '10-7 با موفقیت تایید شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.confirmOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.confirmOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    cancelOutOfServicePhoneFunction: function () {
      if (!this.cancelNote) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        id: this.outOfServicePhoneId,
        cancelReason: this.cancelNote,
      };
      this.$store.dispatch('cancelOutOfServicePhone', data).then(() => {
        if (this.$store.state.outOfServicePhoneModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          this.cancelModal = false;
          this.cancelNote = '';
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfAllActive107Codes();
          this.getListOfAllActiveAlarm107Codes();
          this.snackText = '10-7 با موفقیت لغو شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.outOfServicePhoneModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.cancelOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.outOfServicePhoneModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.cancelOutOfServicePhoneFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.outOfServicePhoneModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
